/**
 * Story 054 — Offshore / Onshore pill (UX brief §3.5).
 *
 * Re-uses existing chip tokens — info-blue for Offshore (the noteworthy
 * state) and neutral grey for Onshore (the default). Both carry a
 * literal text label so colour is not the only signal (WCAG 1.4.1).
 */
import type { ReactElement } from "react";
import { Chip } from "@mui/material";

export function OffshoreChip({
  isOffshore,
}: {
  isOffshore: boolean;
}): ReactElement {
  if (isOffshore) {
    return (
      <Chip
        size="small"
        label="Offshore"
        sx={(t) => ({
          fontWeight: 500,
          bgcolor:
            t.palette.mode === "dark"
              ? "rgba(41, 151, 255, 0.18)"
              : "rgba(0, 113, 227, 0.10)",
          color: t.palette.primary.main,
          border: "none",
        })}
      />
    );
  }
  return (
    <Chip
      size="small"
      label="Onshore"
      sx={(t) => ({
        fontWeight: 500,
        bgcolor: t.palette.background.paper,
        color: t.palette.text.secondary,
        border: "none",
      })}
    />
  );
}

export function InactiveBadge(): ReactElement {
  return (
    <Chip
      size="small"
      label="Inactive"
      variant="outlined"
      sx={(t) => ({
        fontWeight: 500,
        ml: 1,
        color: t.palette.warning.main,
        borderColor: t.palette.warning.main,
      })}
    />
  );
}
